<template>
    <h6 class="mb-0">{{ titlePage }}</h6>
    <p class="mb-0 text-sm">{{ subtitlePage }}</p>
    <hr class="my-3 horizontal dark" />

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="section" class="form-label">Section</label>
          <input id="section" type="text" class="form-control" v-model="record.section" />
        </div>
        <div class="form-group">
          <label for="sequence" class="form-label">Sequence</label>
          <input id="sequence" type="number" class="form-control" v-model="record.sequence" />
        </div>
        <div class="form-group">
          <label for="target_url" class="form-label">Target Url</label>
          <input id="target_url" type="text" class="form-control" v-model="record.target_url" />
        </div>
        <div class="form-group">
          <label for="image" class="form-label">Image</label>
          <input id="image" type="file" class="form-control" @change="onFileChanged()" ref="file" accept="image/*" />
        </div>
      </div>
      <div class="col-6">
        <img :src="this.record.image_url || defaultImg" class="img img-thumbnail "/>
      </div>
    </div>
    
    
    <div class="mt-4 d-flex justify-content-end">
      <button type="button" name="button" class="m-0 btn btn-light" @click="onCancel()">
          Cancel
      </button>
      <button
          type="button"
          name="button"
          class="m-0 btn bg-gradient-success ms-2"
          @click="onSubmitNew(record)"
      >
          {{ submitButtonName }}
      </button>
    </div>
</template>
<script>
  import defaultImg from "@/assets/img/no-preview-4.png";
  import FileService from "@/services/files.service.js";

  export default {
    data() {
      return {
        record: {},
        defaultImg,
      };
    },
    props: {
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        showLoading: { type: Function },
        hideLoading: { type: Function },
        showFailed: { type: Function },
        onCancel: { type: Function },
        recordProps: { type: Object }
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
          console.log('Prop changed: ', newVal, ' | was: ', oldVal)
          this.record = newVal
        }
    },
    mounted() {
    
    },

    methods: {
      onSubmitNew(e){
        const files = this.$refs.file.files

        if(files.length != 0){
          // this.showLoading()
          let fileUpload1 = new FormData();
          fileUpload1.append('files', files[0]);

          FileService.upload(fileUpload1).then((resUpload) => {
            this.hideLoading()
            this.record.image_url = resUpload.data.file_url
            this.onSubmit(this.record)
          }).catch((error) => {
            console.log(error)
            this.hideLoading()
            this.showFailed('Failed to upload image')           
          });
        }else{
          this.hideLoading()
          this.onSubmit(e)
        }
      },
      onFileChanged() {
        const files = this.$refs.file.files
        const file = files[0]
        this.record.image_url = URL.createObjectURL(file)
      }
    }
  }
  </script>
  